import { render, staticRenderFns } from "./PaymentAttributeList.vue?vue&type=template&id=7697866c"
import script from "@/controllers/custom/payment_attribute/payment-attribute-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/payment_attribute/payment-attribute-list.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeList.vue?vue&type=style&index=0&id=7697866c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports